// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"e14416f0","864":"72dd16b8","900":"f15fc878","941":"f07ec45a"}[chunkId] + ".chunk.js";
};